import Swiper, {Autoplay, Navigation, Scrollbar} from 'swiper';
import {showModal} from "../../../../default/global/js/modal";
import {initImageGallery} from "../../../../default/global/js/imageGallery";
import {openFullscreenGallery} from "../../../../default/global/js/fullscreengallery";
import {initExpandableText} from "./showMoreText";

export function initSpielraeumeModal() {
    const collection = document.querySelector('.spielraeume.isList:not(.preview)');
    if (!collection) return;

    const modal = document.getElementById('spielraeumeModal');
    if (!modal) return;

    collection.addEventListener('click', function(e) {
        const trigger = e.target.closest('[data-spielraum-id]');
        if (!trigger) return;
        e.preventDefault();

        const id = trigger.dataset.spielraumId;
        const template = document.querySelector(`template[data-spielraum-tpl="${id}"]`);
        if (!template) return;

        const modalBody = modal.querySelector('.modal__body');
        modalBody.innerHTML = '';
        modalBody.appendChild(template.content.cloneNode(true));

        initImageGallery(modalBody.querySelectorAll('.imageGallery'));

        for (const item of modalBody.querySelectorAll('.js-openGallery')) {
            item.addEventListener('click', function() {
                openFullscreenGallery(item);
            });
        }

        showModal(modal);

        // Erst nach showModal: davor ist das Modal display:none, der Text hat
        // dann keine messbare Hoehe und der Umschalter "Mehr anzeigen" wuerde
        // faelschlich als ueberfluessig ausgeblendet.
        const fulltext = modalBody.querySelector('.fulltext');
        if (fulltext) {
            fulltext.classList.remove('active');
            initExpandableText(fulltext);
        }
    });
}

export function inizializeCollectionSwiper() {
    const swiperWrapper = document.querySelector('.spielraeumeSwiper');
    if(swiperWrapper) {
        const swiperElements = swiperWrapper.querySelectorAll(".swiper-slide").length

        if(swiperElements > 1) {
            var swiper = new Swiper(".spielraeumeSwiper", {
                slidesPerView: 3,
                spaceBetween: 8,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        } else {
            swiperWrapper.querySelector('.swiper-interaction').classList.add('hidden');
        }

    }
}